// extracted by mini-css-extract-plugin
export default {"OpenInNewIcon":"index__OpenInNewIcon__E7egO","Tag":"index__Tag__A8Vk6"};